import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for deviceModelAttributes.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.DEVICE_MODEL_ATTRIBUTES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const DeviceModelAttributeService = {
  FindMany
}

export default DeviceModelAttributeService
